import { useTranslation } from 'react-i18next';

import type { User } from '~/types/user';

import { useApproveAccountant, useUnlinkAccountant } from '~/api/user';
import { Button } from '~/components';
import { toast } from '~/utils/toast';

import { accountantStyle, labelStyle, wrapperStyle } from './Accountant.css';

type Props = {
  accountant: NonNullable<User['accountant']>;
};

export const Accountant = ({ accountant }: Props) => {
  const unlinkAccountantMutation = useUnlinkAccountant();
  const approveAccountantMutation = useApproveAccountant();

  const { t } = useTranslation(['common', 'settings']);

  const approveAccountant = () => {
    approveAccountantMutation.mutate(undefined, {
      onSuccess: () => toast.success({ description: t('settings:alerts.integrations.successAccountantLinked') }),
      onError: () => toast.danger({ description: t('common:error') }),
    });
  };

  const unlinkAccountant = () => {
    unlinkAccountantMutation.mutate(undefined, {
      onSuccess: () => toast.success({ description: t('settings:alerts.integrations.successAccountantUnlinked') }),
      onError: () => toast.danger({ description: t('common:error') }),
    });
  };

  return (
    <div className={wrapperStyle}>
      <p className={labelStyle}>{t(`settings:integrations.accountant.${accountant.approved ? 'current' : 'requested'}`)}</p>

      <p className={accountantStyle}>
        {accountant.data.firstName} {accountant.data.lastName} ({accountant.data.email})
      </p>

      {accountant.approved ? (
        <Button emphasis="secondary" icon="Trash" loading={unlinkAccountantMutation.isPending} onClick={unlinkAccountant}>
          {t('settings:integrations.accountant.unpair')}
        </Button>
      ) : (
        <Button loading={approveAccountantMutation.isPending} onClick={approveAccountant}>
          {t('settings:integrations.accountant.pair')}
        </Button>
      )}
    </div>
  );
};
